const generateLinkWithParams = (params, route) => {
    return JSON.stringify(params) === '{}' ? route :
        route + '?' + Object.keys(params).map(
            key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
        ).join('&')
}

export {
    generateLinkWithParams
}